import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Utilities } from '../../../common/utilities';
import { BOOdontologyRadiologicExamType } from '../../../models/odo/BOOdontologyRadiologicExamType.model';
import { OdontologyRadiologicExamTypeService } from '../../../services/odo/OdontologyRadiologicExamType.service';

@Component({
  selector: 'app-odontology-radiologic-exam-patient',
  templateUrl: './odontology-radiologic-exam-patient.component.html',
  styleUrls: ['./odontology-radiologic-exam-patient.component.css']
})
export class OdontologyRadiologicExamPatientComponent implements OnInit {

    @Input() id!: number;
    @Input() itemType!: string;
    @Input() itemName!: string;
    @Input() details!: string;
    @Input() posInArray!:number;
    @Input() uniqueId!: string;
    @Output() posSended = new EventEmitter<{ uniqueId: string }>(); // ← Cambia el tipo
    @Output() posSendedId = new EventEmitter<{ itemId: number, tipo:string, details:string }>(); // ← Cambia el tipo


  // tissueTypeList:BOOdontologyTissueType[]=[];
    rediologicTypeList:BOOdontologyRadiologicExamType[]=[];



  constructor( private _formBuilder : FormBuilder,
               private _odontologyRadiologicExamTypeService      : OdontologyRadiologicExamTypeService
  )
  { }

  radiologyFormGroup = this._formBuilder.group({
    posInArray:{ value: null, disabled: true },
    itemName: { value: null, disabled: true },
    details: { value: null},
  })

  ngOnInit(): void {

    this._odontologyRadiologicExamTypeService.getAll().subscribe({
      next:(data)=>
      {
        this.rediologicTypeList=data;
        console.log("EN ODONTOLOGY-RADIOLOGY-EXAM-PATIENT  this.rediologicTypeListn es:",  this.rediologicTypeList);

        this.radiologyFormGroup.patchValue({
        posInArray: this.posInArray +1,
        itemName: Utilities.getRelativeTypeName(this.itemType, this.rediologicTypeList),
        details:this.details
       })

      },
      error:(err)=>{
        console.log("Ocurrió un error en la descarga de tipo parientes");
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Evitamos el primer cambio porque ngOnInit ya lo maneja
    if (changes['posInArray'] && !changes['posInArray'].firstChange) {
      this.radiologyFormGroup.patchValue({
        posInArray: this.posInArray + 1
      });
    }
  }

deleteItem(): void {
  this.posSended.emit({ uniqueId: this.uniqueId }); // ← Emite ID, no posición
}

deleteItemSingle(): void {
  let details=this.radiologyFormGroup.get('details').value;
  this.posSendedId.emit({ itemId: this.id, tipo:'del', details:details}); // ← Emite ID, no posición
}


editItemSingle(): void {
   let detailsTemp=this.radiologyFormGroup.get('details').value;
   console.log("En EDITITEMSINGLE ANTES DE ENVIAR itemId es:", this.id);

  this.posSendedId.emit({ itemId: this.id, tipo:'edi', details:detailsTemp }); // ← Emite ID, no posición
}

}
